var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 22.75H2C1.59 22.75 1.25 22.41 1.25 22C1.25 21.59 1.59 21.25 2 21.25H22C22.41 21.25 22.75 21.59 22.75 22C22.75 22.41 22.41 22.75 22 22.75Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6.22993C13.56 6.22993 12.62 6.04995 11.72 5.68995C11.44 5.57995 11.25 5.29994 11.25 4.98994V1.98994C11.25 1.73994 11.37 1.50995 11.58 1.36995C11.79 1.22995 12.05 1.19993 12.28 1.28993C13.71 1.85993 15.29 1.85993 16.72 1.28993C16.95 1.19993 17.21 1.22995 17.42 1.36995C17.63 1.50995 17.75 1.73994 17.75 1.98994V4.98994C17.75 5.29994 17.56 5.56995 17.28 5.68995C16.38 6.04995 15.44 6.22993 14.5 6.22993ZM12.75 4.46992C13.89 4.81992 15.11 4.81992 16.25 4.46992V3.01997C15.1 3.29997 13.9 3.29997 12.75 3.01997V4.46992Z",
    fill: "#121212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.75C11.59 8.75 11.25 8.41 11.25 8V5C11.25 4.59 11.59 4.25 12 4.25C12.41 4.25 12.75 4.59 12.75 5V8C12.75 8.41 12.41 8.75 12 8.75Z",
    fill: "#121212"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22.75H4C3.59 22.75 3.25 22.41 3.25 22V11C3.25 8.58 4.58 7.25 7 7.25H17C19.42 7.25 20.75 8.58 20.75 11V22C20.75 22.41 20.41 22.75 20 22.75ZM4.75 21.25H19.25V11C19.25 9.42 18.58 8.75 17 8.75H7C5.42 8.75 4.75 9.42 4.75 11V21.25Z",
    fill: "#121212"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4201 12.75H4.58008C4.17008 12.75 3.83008 12.41 3.83008 12C3.83008 11.59 4.17008 11.25 4.58008 11.25H19.4201C19.8301 11.25 20.1701 11.59 20.1701 12C20.1701 12.41 19.8301 12.75 19.4201 12.75Z",
    fill: "#121212"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74023 12H7.24023V22H8.74023V12Z",
    fill: "#121212"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7402 12H11.2402V22H12.7402V12Z",
    fill: "#121212"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7402 12H15.2402V22H16.7402V12Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalIcon);
export default __webpack_public_path__ + "static/media/legal-icon.1baf9b093f5b5cd7b75a0014bffe2f17.svg";
export { ForwardRef as ReactComponent };